var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.order.urgent)?_c('el-tag',{attrs:{"size":"small","type":"danger"}},[_vm._v("加急")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }